import { find, get, some } from 'lodash';

/*
  user object sample:
  {
    groups: [
      {
        group: {
          id: 'group_id_123'
        },
        roles: [
          {
            role_type: 'primary',
            name: 'Case Manager',
          }
        ]
      }
    ],
  }
*/
function hasUserRole(_ref) {
  var groupId = _ref.groupId,
    name = _ref.name,
    roleType = _ref.roleType,
    user = _ref.user;
  var group = find(get(user, 'groups', []), function (group) {
    return group.group.id === groupId;
  });
  return some(get(group, 'roles', []), {
    role_type: roleType,
    name: name
  });
}
export default hasUserRole;
//# sourceMappingURL=hasUserRole.js.map